import { useCallback } from 'react';
import { motion } from 'framer-motion';
import { useAppContext } from 'contexts/AppContext';
import { useState, useMemo, useRef, useEffect } from "react";
import { getMinutesWSeconds, heart, timeSleep, track } from 'utils/index';
import styles from './AnimatedVideoThumbnail.module.scss';

const AnimatedVideoThumbnail = ({video, delay=0}) => {

    const { playOnTap, isTapHoldExperiment } = useAppContext();
    const [hovering, setHovering] = useState(false)
    const hoveringRef = useRef()
    const [hasHovered, setHasHovered] = useState(false)

    function play(e){
        if(e.target.readyState !== 4){
            e.target.addEventListener('loadeddata', ()=>e.target.play(), false);
        }else{
            e.target.play()
        }
    }

    const handleHover = useCallback(async (e, isHovering) => {
        !hasHovered && setHasHovered(true)
        hoveringRef.current = isHovering
        try{
            if(!playOnTap && isTapHoldExperiment) return
            if(isHovering){
                play(e)
            }else{
                e.target.pause()
            }
        }catch(e){
            console.log('Play / pause action interrupted.')
        }
        isHovering && await timeSleep(delay)
        if(!(!hoveringRef.current && isHovering)){
            setHovering(isHovering)
        }
    }, [hasHovered, hoveringRef, playOnTap, delay, isTapHoldExperiment])


    function handleClick(){
        video.abTestingThumbnail && track('AB Test Thumbnail Clicked', {
            video_id: video.video_id,
            video_title: video.title,
            variant: video.poster.replace(/[^0-9]/g, '')
        })
    }

    const minutesWSeconds = useMemo(()=>getMinutesWSeconds(video.length), [video.length])

    return (
        <motion.div className={styles.animatedVideoThumbnail} whileTap={{scale: .95}} onClick={handleClick}>
            <img src={video.poster} alt="" style={{opacity: hovering ? 0 : 1}} />
            <div
            onMouseEnter={(e)=>handleHover(e, true)} 
            onMouseLeave={(e)=>handleHover(e, false)}
            onTouchStart={(e)=>handleHover(e, true)} 
            onTouchEnd={(e)=>handleHover(e, false)}
            >
                <video 
                src={hasHovered ? video.preview : ""} 
                poster={video.poster ? video.poster : video.thumbnail_url}
                loop="loop" 
                muted={true} 
                playsInline={true} 
                >
                    <source src={video.preview} />
                </video>
                <FavHeart hovering={hovering} video={video} />
                <div 
                data-type="length" 
                className={styles.length} 
                style={{opacity: hovering ? 0 : 1}}
                >
                    {minutesWSeconds}
                </div>
            </div>
        </motion.div>
    )
}

const FavHeart = ({hovering, video}) => {
    
    const { favorites, addFavorite, removeFavorite } = useAppContext();
    const [isFavorite, setIsFavorite] = useState(favorites.includes(video.video_id))
    
    function handleFavClick(){
        setIsFavorite(!isFavorite)
        !isFavorite ? addFavorite(video) : removeFavorite(video)
    }

    useEffect(()=>{
        setIsFavorite(favorites.filter(favorite => favorite.video_id === video.video_id).length > 0) 
    }, [favorites.length])

    return (
        <div 
        className={`${styles.FavHeart} ${isFavorite ? styles['FavHeart-isFavorite'] : ''}`}
        onClick={(e)=>{e.stopPropagation(), e.preventDefault(), handleFavClick()}}
        style={{opacity: hovering ? 1 : 0}}
        >
            {heart(14)}
        </div>
    )
}

export default AnimatedVideoThumbnail;